export const DEFAULT_VIDEO_CROSSORIGIN = 'anonymous';
